module.exports = __webpack_public_path__ + "static/media/forwards.d5ccce94.svg";